/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/*================ Helper Functions ================*/
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500, display = 'block') {
  target.style.opacity = 0;
  target.style.display = display;
  var last = +new Date();
  var tick = function() {
    target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else {}
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function() {
    target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else{
        target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

function addToCart(body, openCart = true) {
  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then((response) => response.json())
  .then((parsedState) => {
    atcGetSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    if (openCart) {
      document.querySelector('cart-drawer').open();
    }
  });
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

// To Top
const toTopElements = document.querySelectorAll('.back-to-top');
toTopElements.forEach(el => {
  el.addEventListener('click', event => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

/*================ Initialize ================*/
// Micromodal
MicroModal.init({
  onClose: modal => pauseAllMedia(),
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

/*================ Animations ================*/
// Init plugins
gsap.registerPlugin(ScrollTrigger);

// Fade In
const fadeInElems = gsap.utils.toArray('.fade-in');
fadeInElems.forEach(elem => {
  const duration = Number(elem.dataset.duration);
  const delay = Number(elem.dataset.delay);

  gsap.to(elem, { 
    opacity: 1,
    duration: duration || .8,
    delay: delay || 0,
    ease: 'linear',
    scrollTrigger: {
      trigger: elem,
      start: "top 92%"
    }
  });
});

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.pageOverlayElement = document.querySelector('.page-overlay');
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  openMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

var VariantSelects = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateActiveVariantText(event);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateActiveVariantText(event) {
    let value = event.target.closest('input:checked').value;
    const activeTextEl = this.querySelector('.product-form__active-variant');
    const isSize = event.target.classList.contains('product-form__variant-input--size');

    if (isSize) {
      switch (value) {
        case 'XS':
          value = 'Extra Small';
          break;
        case 'S':
          value = 'Small';
          break;
        case 'M':
          value = 'Medium';
          break;
        case 'L':
          value = 'Large';
        default:
          value;
      }

      activeTextEl.innerHTML = value;
    }

  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

var VariantRadios = class extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

var AddToCart = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const id = this.dataset.id;

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    addToCart(body);
  }
}

customElements.define('add-to-cart', AddToCart);

var FaqItem = class extends HTMLElement {
  constructor() {
    super();

    this.faqButton = this.querySelector('.faq-item__header');
    this.faqButton.addEventListener('click', this.onFaqClick.bind(this));
  }

  onFaqClick(event) {
    const header = event.currentTarget;
    const parent = header.parentElement;
    const content = parent.querySelector('.faq-item__content');

    if (parent.classList.contains('active')) {
      parent.classList.remove('active');
      slideUp(content, 400);
    } else {
      parent.classList.add('active');
      slideDown(content, 400);
    }
  }
}

customElements.define('faq-item', FaqItem);

var ClassPreview = class extends HTMLElement {
  constructor() {
    super();

    this.navItems = this.querySelectorAll('.class-preview__nav-item');
    this.playButtons = this.querySelectorAll('.class-preview__video-play');
    this.video = this.querySelector('video');
    this.lightbox = this.querySelector('.class-preview__lightbox');
    this.overlay = this.querySelector('.class-preview__lightbox-overlay');

    this.navItems.forEach(item => item.addEventListener('click', this.handleNavClick.bind(this)));
    this.playButtons.forEach(button => button.addEventListener('click', this.handlePlayButtonClick.bind(this)));
  }

  handleNavClick() {
    const tab = event.currentTarget.dataset.tab;

    // Change active nav item
    this.querySelector('.class-preview__nav-item.active').classList.remove('active');
    event.currentTarget.classList.add('active');

    // Swap out preview image
    this.querySelector('.class-preview__video.active').classList.remove('active');
    this.querySelector('.class-rotating-text-mobile.active').classList.remove('active');
    this.querySelector('.class-rotating-text-desktop.active').classList.remove('active');
    console.log('heee',this.querySelector('.class-rotating-text-desktop.active'))
    this.querySelector(`.class-preview__video[data-tab="${tab}"]`).classList.add('active');
    this.querySelector(`.class-rotating-text-mobile[data-tab="${tab}"]`).classList.add('active');
    this.querySelector(`.class-rotating-text-desktop[data-tab="${tab}"]`).classList.add('active');
  }

  handlePlayButtonClick() {
    const url = event.currentTarget.dataset.url;

    this.video.setAttribute('src', url);
    this.video.play();
    this.openLightBox();
  }

  openLightBox() {
    this.lightbox.classList.add('is-open');

    this.overlay.addEventListener('click', this.closeLightBox.bind(this));
    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeLightBox());
  }

  closeLightBox() {
    pauseAllMedia();
    this.lightbox.classList.remove('is-open');
  }
}

customElements.define('class-preview', ClassPreview);

var CollectionFilters = class extends HTMLElement {
  constructor() {
    super();
    
    this.tagButtons = this.querySelectorAll('.collection-filters__tag');
    this.sortDropdowns = this.querySelectorAll('.collection-filters__sort-button');
    this.sortButtons = this.querySelectorAll('.collection-filters__sort');
    this.overlay = this.querySelector('.collection-filters__overlay');
    
    this.collectionURL = this.dataset.collectionUrl;
    this.currentTag = this.dataset.currentTags;
    this.temporaryTag = '';
    this.sortBy = this.dataset.currentSort;

    this.setListeners();
  }

  setListeners() {
     // Functionality to click out of dropdown
    this.overlay.addEventListener('click', event => {
      document.querySelector('.collection-filters__item.active').classList.remove('active');
      this.overlay.classList.remove('active');
    });

    // Handle Filter Click
    this.tagButtons.forEach(tagButton => {
      tagButton.addEventListener('click', this.handleFilterClick.bind(this, tagButton));
    });

    // Sort Dropdown Open / Close
    this.sortDropdowns.forEach(sortDropdown => {
      sortDropdown.addEventListener('click', this.handleSortDropdown.bind(this, sortDropdown));
    });

    // Handle Sort Click
    this.sortButtons.forEach(sortButton => {
      sortButton.addEventListener('click', this.handleSortClick.bind(this, sortButton));
    });

    // On Overlay Click
    this.overlay.addEventListener('click', event => {
      const activeDropdownContainer = document.querySelector('.collection-filters__sort-dropdown.active');
      const activeDropdown = activeDropdownContainer.querySelector('.collection-filters__dropdown');

      activeDropdownContainer.classList.remove('active');
      this.overlay.classList.remove('active');
      fadeOut(activeDropdown, 400);
    });

    // Hide sort bar on mobile bar
    const sortBar = document.querySelector('.collection-filters__right');
    const triggerPoint = sortBar.getBoundingClientRect().top;
    document.addEventListener('scroll', event => {
      const fromTop = window.scrollY;

      if (window.innerWidth < 769) {
        if (fromTop > triggerPoint) {
          if (!sortBar.classList.contains('is-hidden')) {
            sortBar.classList.add('is-hidden')
          }
        } else {
          if (sortBar.classList.contains('is-hidden')) {
            sortBar.classList.remove('is-hidden')
          }
        }
      }
    });
  }

  handleFilterClick(tagButton, event) {
    const filter = tagButton.dataset.value;
    
    if (!tagButton.classList.contains('active')) {
      const activeSibling = document.querySelector('.collection-filters__tag.active');

      if (activeSibling) {
        activeSibling.classList.remove('active');
      }

      tagButton.classList.add('active')
      this.temporaryTag = filter;
    }

    this.reloadSections();
  }

  handleSortDropdown(sortDropdown, event) {
    const parent = sortDropdown.parentElement;
    const dropdown = sortDropdown.nextElementSibling;

    // Toggle dropdowns
    if (parent.classList.contains('active')) {
      parent.classList.remove('active');
      this.overlay.classList.remove('active');
      fadeOut(dropdown, 400);
    } else {
      parent.classList.add('active');
      this.overlay.classList.add('active');
      fadeIn(dropdown, 400);
    }
  }

  handleSortClick(sortButton) {
    const sort = sortButton.dataset.value;
    const sortName = sortButton.dataset.name;

    if (!sortButton.classList.contains('active')) {
      // Make clicked button active
      this.querySelector('.collection-filters__sort.active').classList.remove('active');
      sortButton.classList.add('active');

      this.sortBy = sort;

      this.currentTags = this.currentTags.filter(el => el != '');
      this.reloadSections();

      // Change Active Text
      const nameEl = document.querySelector('.collection-filters__sort-name');
      nameEl.innerHTML = sortName;

      // Close Sort Dropdown
      const activeDropdownContainer = document.querySelector('.collection-filters__sort-dropdown.active');
      const activeDropdown = activeDropdownContainer.querySelector('.collection-filters__dropdown');

      activeDropdownContainer.classList.remove('active');
      this.overlay.classList.remove('active');
      fadeOut(activeDropdown, 400);
    }
  }

  reloadSections() {
    // Change URL
    const newUrl = window.location.protocol + '//' + window.location.host + this.collectionURL + '/' + this.temporaryTag + '?sort_by=' + this.sortBy;
    
    if (history.replaceState) {
      window.history.pushState({ path: newUrl }, '', newUrl);
    }

    // Fetch and replace sections
    this.enableLoading();
    fetch(location.pathname + '?sort_by=' + this.sortBy)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        this.getSectionsToRender().forEach((section => {
            document.getElementById(section.id).innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(section.id).innerHTML;
        }));
      
        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'ProductGridContainer'
      },
      {
        id: 'CollectionFilterProductTotal'
      }
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
  }

  disableLoading() {
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
  }
}

customElements.define('collection-filters', CollectionFilters);